import { OptionalAppRoute } from '../types';
import { createRelativeUrl, stripAnyAppPrefixFromUrl } from '../utils';

const createUrl = (route: OptionalAppRoute) => {
    const relativeUrl = createRelativeUrl({
        ...route,
        query: {
            site: route.instanceSlug,
        },
    });
    const urlWithoutAppPrefix = stripAnyAppPrefixFromUrl(relativeUrl);

    if (window.BeekeeperRouterBridge && route.appId) {
        const url = route.externalAppId ? urlWithoutAppPrefix : `/la${urlWithoutAppPrefix}`;
        return window.BeekeeperRouterBridge?.getUrl?.(route.appId, url) || url;
    }

    const lumappsUrl = `${window.LumappsContext.tenantUrl}${urlWithoutAppPrefix}`;

    return lumappsUrl;
};

export const webComponentsRouterApi = {
    redirect: (route: OptionalAppRoute) => {
        const url = createUrl(route);

        if (window.BeekeeperRouterBridge && url) {
            window.BeekeeperRouterBridge.push(url);
        }
    },
    getUrl: createUrl,
};
